import { render, staticRenderFns } from "./tree-core.vue?vue&type=template&id=72cb4736&scoped=true&"
import script from "./tree-core.vue?vue&type=script&lang=js&"
export * from "./tree-core.vue?vue&type=script&lang=js&"
import style0 from "./tree-core.vue?vue&type=style&index=0&id=72cb4736&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72cb4736",
  null
  
)

export default component.exports